/* @flow */
import * as React from 'react';
import classnames from 'classnames/bind';

import s from './TabbedUI.styl';
const cx = classnames.bind(s);

/**
 * This is just responsible for defining expected prop types and rendering
 * children
 */
class Tab extends React.PureComponent {
  props: {
    title: string,
    activeKey: string,
    children: $TODO,
  };

  render() {
    return this.props.children;
  }
}

/**
 * Creates a horizontal tabbed UI. This is a controlled component: both
 * activeTab and onChange props are mandatory.
 *
 * The children of the active tab will be rendered. The active tab is determined
 * by the activeTab prop and the various activeKey props of each tab
 */
export class TabbedUI extends React.PureComponent {
  static Tab = Tab;

  static defaultProps = {
    innerClassName: '',
  };

  props: {
    activeTab: string,
    onChange: (tab: string, e: SyntheticMouseEvent) => void,
    children: $TODO,
    className?: string,
    innerClassName?: string,
  };

  render() {
    const {
      activeTab,
      onChange,
      className,
      innerClassName,
      children: _children,
      ...props
    } = this.props;
    const children = React.Children.toArray(_children);
    const activeChild = children.find(
      ({ props: childProps }) => childProps.activeKey === activeTab
    );

    return (
      <div className={cx('TabbedUI', className)} {...props}>
        <nav className={cx('tabs')}>
          {children.map(({ props: childProps }) => {
            const isActive = childProps.activeKey === activeTab;
            return (
              <div
                key={childProps.activeKey}
                className={cx('tab', { active: isActive })}
                onClick={e => {
                  onChange(childProps.activeKey, e);
                  if (isActive && childProps.onActiveClick) {
                    childProps.onActiveClick(e);
                  }
                }}>
                {childProps.title}
              </div>
            );
          })}
        </nav>
        <div className={cx('activeChild', innerClassName)}>{activeChild}</div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./web_modules/trustar/components/TabbedUI.js